/* eslint-env browser */
import { countries, getEmojiFlag } from 'countries-list'
import * as React from 'react'

const PropTypes = require('prop-types')

const Table = require('../../../client/clientjs/components/Table')

class Teams extends React.Component {
  constructor(props) {
    super(props)

    const { teams, displayZone, contestSeoName } = props

    const displayNationality = teams.some(row => {
      const captain = row.members.find(member => member.isCaptain)
      return captain && !!captain.nationality
    })

    const columns = [
      {
        name: 'name',
        display: 'Team',
        getCellValue: row => (
          <a href={`/contests/${contestSeoName}/teams/${row.id}`} target="_blank">
            {row.name}
          </a>
        ),
        isSortable: true,
        getCellRawValue: row => row.name,
      },
    ]
    if (displayNationality) {
      columns.push({
        name: 'countryOrigin',
        display: ' ',
        getCellValue: row => {
          const captain = row.members.find(member => member.isCaptain)
          if (!captain || !captain.nationality) {
            return null
          }
          return (
            <span
              style={{ fontSize: '1.6em' }}
              className="tooltip tooltip-top"
              data-tooltip={(countries[captain.nationality.toUpperCase()] || {}).name || captain.nationality}
            >
              {getEmojiFlag(captain.nationality)}
            </span>
          )
        },
        isTextCentered: true,
      })
    }
    if (displayZone) {
      columns.push({
        name: 'contestZoneName',
        display: 'Zone',
        getCellValue: row => row.contestZoneName,
      })
    }

    this.state = {
      teams: teams.sort((a, b) => {
        const ac = (a.metadata || {}).completedAt
        const bc = (b.metadata || {}).completedAt
        return ac - bc
      }),
      columns,
    }
  }

  render() {
    const { columns, teams } = this.state

    return (
      <Table rows={teams} columns={columns} getRowKey={row => row.id} isFullWidth defaultSortBy="name" defaultSortASC />
    )
  }
}

Teams.propTypes = {
  teams: PropTypes.array,
  contestSeoName: PropTypes.string.isRequired,
  displayZone: PropTypes.bool,
}

Teams.defaultProps = {
  teams: [],
  displayZone: false,
}

module.exports = Teams
